// ** React Imports
import { useContext } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";

// ** Location AutoComplete Data
import { distanceListFn } from "../data/distanceList";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const DistanceSelector = ({
	location,
	handleLocationSelect,
	subscribeActualOpenSelectorEvent,
	customMobileLayerStyle,
	activatorStyleOptions,
	useLayerOptions,
	noPad,
}) => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const kmText = t("common:km");
	const distanceList = distanceListFn(kmText);

	const { isPhone } = useContext(deviceTypeContext);

	// #####################################################

	return (
		<SelectorSelectSingle
			selectorKey="loactionAutocomplete_distanceSelector"
			label={t("filtersAndSelectors:distanceLabel")}
			emptyText={t("common:any.3")}
			items={distanceList}
			selected={location?.distance || 0}
			onAccept={(value) => {
				handleLocationSelect({
					cityName: location?.cityName,
					cityId: location?.cityId,
					regionName: location?.regionName,
					regionId: location?.regionId,
					country: location?.country,
					distance: value,
					url: location?.url,
					accept: true,
				});
			}}
			customMobileLayerStyle={customMobileLayerStyle}
			customLayerStyle={{ zIndex: isPhone ? 1000 : 499 }}
			useLayerOptions={useLayerOptions}
			activatorWrapperStyle={{ minWidth: "106px" }}
			activatorStyle={{
				borderTopLeftRadius: "0px",
				borderBottomLeftRadius: "0px",
			}}
			activatorStyleOptions={{
				noPad: noPad,
				...activatorStyleOptions,
			}}
			withMobileVersion
			subscribeActualOpenSelectorEvent={subscribeActualOpenSelectorEvent}
		/>
	);
};

export default DistanceSelector;

// #####################################################
